export default "__VITE_ASSET__DdcWa9xQ__"